import type { RootState } from '@/app/store';
import { Saving } from '@/interfaces/saving';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDefaultCurrency, getReferenceCurrency } from '@/utils/currencyConfig';

const tempData: Saving[] = [
  {
    id: '43',
    title: 'Saving Plan 1',
    account: { number: '11111111111-11', name: 'Main Account', currency: getDefaultCurrency() },
    amount: 9843,
    duration: '12 Months',
    notification: 'SMS',
    frequency: 'Weekly',
    initialContribution: 5454,
    periodContribution: 1221,
    date: '11/12/2024',
    manualPlan: false,
  },
  {
    id: '4332423',
    title: 'Saving Plan HELLO',
    account: { number: '12311321111-11', name: 'Main Account', currency: getReferenceCurrency() },
    amount: 10000,
    duration: '4 Years',
    notification: 'Both',
    frequency: 'Weekly',
    initialContribution: 5454,
    periodContribution: 1221,
    date: '11/12/2024',
    manualPlan: true,
  },
];

interface FilterParams {
  page: number | undefined;
  size: number | undefined;
}

interface MetaData {
  totalPages: number;
  totalElements: number;
}

interface SavingState {
  savingPlans: { [key: string]: Saving[] };
  loading: boolean;
  currFilters: string;
  metaData: { [key: string]: MetaData };
  params: FilterParams;
}

const initialState: SavingState = {
  savingPlans: {},
  loading: false,
  currFilters: '',
  metaData: {},
  params: { page: undefined, size: undefined },
};

export const fetchSavings = createAsyncThunk('savings/fetch', async ({ size, page }: { size: number; page: number }, thunkAPI) => {
  try {
    // const result = await savingPlansServices.fetchSavings({ size, page: page - 1 });
    const result = { data: tempData, totalPages: 1, totalElements: 2 };
    return result;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.data);
  }
});

export const savingsSlice = createSlice({
  name: 'savings',
  initialState,
  reducers: {
    refresh: () => initialState,
    handleParamsChange: (state, action: PayloadAction<{ size: number; page: number }>) => {
      const ticketFilters = JSON.stringify(action.payload);
      state.currFilters = ticketFilters;
      state.params.page = action.payload.page;
      state.params.size = action.payload.size;
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchSavings.pending, state => {
      state.loading = true;
    });

    builder.addCase(fetchSavings.fulfilled, (state, action) => {
      const { payload: data } = action;
      state.savingPlans[state.currFilters] = data.data;
      state.metaData[state.currFilters] = { totalPages: data.totalPages, totalElements: data.totalElements };
      state.loading = false;
    });

    builder.addCase(fetchSavings.rejected, state => {
      state.loading = false;
    });
  },
});

export const { refresh, handleParamsChange } = savingsSlice.actions;

export const selectSavings = (state: RootState) => state.savings;

export default savingsSlice.reducer;
